import MuiAccordion from "@mui/material/Accordion";
import type { AccordionProps as MuiAccordionProps } from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import type { CSSProperties, ReactNode } from "react";

export interface AccordionProps {
  id?: string;
  summary: ReactNode;
  details: ReactNode;
  actions?: ReactNode;
  expanded?: boolean;
  onChange?: MuiAccordionProps["onChange"];
  sx?: MuiAccordionProps["sx"];
}

export function Accordion({
  id,
  summary,
  details,
  actions,
  sx,
  expanded,
  onChange,
}: AccordionProps) {
  const sxColor = (sx as { color?: CSSProperties["color"] } | undefined)?.color;

  return (
    <MuiAccordion sx={sx} expanded={expanded} onChange={onChange} id={id}>
      <AccordionSummary
        sx={{ fontWeight: "bold" }}
        expandIcon={<ExpandMoreIcon sx={{ color: sxColor }} />}
      >
        {summary}
      </AccordionSummary>
      <AccordionDetails>{details}</AccordionDetails>
      <AccordionActions>{actions}</AccordionActions>
    </MuiAccordion>
  );
}
